import React from 'react';
import styled, { css, keyframes } from 'styled-components';
import FullFavoriteHeart from '@catalogo/ui-americanas-desktop-svg/heart-favorite-full.svg';

const Wishlist = ({ sizeIcon, sizeButton, isFavorite, addFavorite, hasBoxShadow, label }) => (
  <Wrapper>
    <Button size={sizeButton} onClick={addFavorite} hasBoxShadow={hasBoxShadow} isFavorite={isFavorite}>
      <FavoriteHeartIcon width={sizeIcon} height={sizeIcon} isFavorite={isFavorite} />
    </Button>
    {label && <Title onClick={addFavorite}>{label}</Title>}
  </Wrapper>
);

const Wrapper = styled.div`
  display: flex;

  &:hover {
    & > button {
      color: ${({ theme }) => theme.primaryColor};
    }

    svg {
      fill: ${({ theme }) => theme.primaryColor};
      stroke: ${({ theme }) => theme.primaryColor};
    }
  }
`;

const popover = keyframes`
  0% {
  transform: scale(1);
  }
  30% {
  transform: scale(1.3);
  }
  100% {
  transform: scale(1);
  }
`;

const explosion = keyframes`
  0% {
    opacity:1;
  }
  99.9% {
    stroke-dashoffset:0;
  }
  100% {
    opacity:0;
  }
`;

const FavoriteHeartIcon = styled(FullFavoriteHeart)`
  ${({ theme, $isFavorite }) =>
    css`
      width: 38px;
      height: 38px;
      margin-right: 7px;
      fill: ${$isFavorite ? theme.primaryColor : 'transparent'};
      stroke: ${$isFavorite ? 'none' : '#888'};
      stroke-width: 2px;

      & > circle {
        stroke-dashoffset: 95;
        opacity: 0;
        stroke-dasharray: 20 78;
      }
    `}
`;

const Button = styled.button`
  padding: 0;
  background-color: transparent;
  width: ${({ size }) => size};
  height: ${({ size }) => size};
  border: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  outline: none;
  position: relative;
  cursor: pointer;

  ${({ hasBoxShadow }) =>
    hasBoxShadow &&
    css`
      box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 5px;
    `}

  ${({ isFavorite, theme }) =>
    isFavorite &&
    css`
      svg {
        fill: ${theme.primaryColor};
        stroke: ${theme.primaryColor};
        animation: 1s ${popover} linear forwards;

        & > circle {
          fill: ${theme.primaryColor};
          stroke: ${theme.primaryColor};
          animation: ${explosion} 0.6s ease;
        }
      }
    `}
`;

const Title = styled.button`
  text-decoration: underline;
  outline: none;
  border: 0;
  background-color: transparent;
  font-size: 14px;
  line-height: 16px;
  font-family: inherit;
  letter-spacing: -0.2px;
  padding: 0px;
  color: #888888;
  cursor: pointer;
`;

export default Wishlist;
